import { Node } from "../../node.js";
/**
 * @public
 */
export function hasChild(predicate, options = Node.Traversal.empty) {
    return (node) => node.children(options).some(predicate);
}
//# sourceMappingURL=has-child.js.map